// ** MUI Imports
import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import MuiToolbar from "@mui/material/Toolbar";
import AppBarContent from "./AppBarContent";
import { Phone } from "src/icons/core";

// ** Util Import
import { hexToRGBA } from "src/@core/utils/hex-to-rgba";
import { Box, Typography } from "@mui/material";

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  transition: "none",
  zIndex: 10,
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "transparent",
  color: theme.palette.text.primary,
  minHeight: theme.mixins.toolbar.minHeight,

  [theme.breakpoints.down("md")]: {
    // display: 'none'
  },
  // [theme.breakpoints.down('sm')]: {
  //   paddingLeft: theme.spacing(4),
  //   paddingRight: theme.spacing(4)
  // }
}));

const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  width: "100%",
  boxShadow: "none !important",
  borderBottom: `1px solid ${theme.palette.secondary.light2} !important`,
  // marginTop: theme.spacing(4),
  // borderRadius: theme.shape.borderRadius,
  padding: "0 30px !important",

  [theme.breakpoints.down("md")]: {
    padding: "0 10px !important",
  },
}));

const LayoutAppBar = (props) => {
  return (
    <AppBar elevation={0} color="default" className="">
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#191919",
          px: 7.5,
          py: 2,
          display: {
            xs: "none",
            lg: "flex",
          },
        }}
      >
        <Typography
          sx={{
            width: "25%",
            color: "white",
            "& span": { color: (theme) => theme.palette.primary.main },
            fontSize: "14px !important",
          }}
        >
          <span>موزونو</span> | خرید مطمئن از آمازون
        </Typography>

        <Typography
          sx={{
            flex: 1,
            textAlign: "center",
            color: "white",
            "& span": {
              color: (theme) => theme.palette.primary.main,
              fontSize: "16px !important",
              fontWeight: "bolder",
            },
            fontSize: "14px !important",
          }}
        >
          کد تخفیف ۱۰۰ هزار تومانی برای اولین خرید : <span>gift</span>
        </Typography>

        <Typography
          sx={{
            width: "25%",
            color: "white",
            textAlign: "end",
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            "& span": { color: (theme) => theme.palette.primary.main },
            fontSize: "14px !important",
          }}
        >
          02191031644
          <Phone sx={{ width: 14, ml: 1 }} />
        </Typography>
      </Box>

      <Toolbar
        className="navbar-content-container"
        sx={{
          // display: 'none',
          // ...(appBarBlur && { backdropFilter: 'blur(6px)' }),
          height: (theme) => `${theme.mixins.toolbar.minHeight}px !important`,
          backgroundColor: `white`,
          // boxShadow: 4
        }}
      >
        <AppBarContent {...props} />
      </Toolbar>
    </AppBar>
  );
};

export default LayoutAppBar;
